import React, { useState } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CSpinner,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Axios from "src/reusable/Axios";
import Swal from "sweetalert2";
import { browserName, osName, osVersion } from 'react-device-detect'
import toastOpt from "src/views/toastopt";

export default function Login() {
  const [loginForm, setLoginForm] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state);
  const [loading, setLoading] = useState(false);

  const submitLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    Axios.post(`${auth.endPoint}/login`, {...loginForm, browserName, osName, osVersion})
      .then(({ data }) => {
        dispatch({ type: "AUTH_LOGIN", user: data });
        history.push("/dashboard");
      })
      .finally(() => setLoading(false))
      .catch((er) => {
        if (er.response) {
          if (er.response.status === 422 || er.response.status === 403) {
            Swal.fire({ ...toastOpt, icon: "error", text: er.response.data });
          }else{
            Swal.fire({ ...toastOpt, icon: "error", text: 'Server error' });
          }
        }else{
          Swal.fire({ ...toastOpt, icon: "error", text: 'Server error' });
        }
      });
  };

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="6">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm id="flogin" onSubmit={submitLogin}>
                    <h1>YI Online Admin</h1>
                    <p className="text-muted">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-user" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        placeholder="Username"
                        onChange={(e) =>
                          setLoginForm({
                            ...loginForm,
                            username: e.target.value,
                          })
                        }
                        autoComplete="username"
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-lock-locked" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="password"
                        placeholder="Password"
                        onChange={(e) =>
                          setLoginForm({
                            ...loginForm,
                            password: e.target.value,
                          })
                        }
                        autoComplete="current-password"
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs="6">
                        <CButton
                          color="primary"
                          type="submit"
                          form="flogin"
                          className="px-4"
                          disabled={loading || !loginForm.username || !loginForm.password}
                        >
                          {loading ? (
                            <CSpinner size="sm" variant="grow" />
                          ) : (
                            "Login"
                          )}
                        </CButton>
                      </CCol>
                      {/* <CCol xs="6" className="text-right">
                        <CButton color="link" className="px-0">
                          Change End Point
                        </CButton>
                      </CCol> */}
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
}
